<template>
  <div id="userLoginPan">
    <i
        @click="loginCheck" title="登录"
        class="el-icon-user-solid"
        style="font-size: 30px;position: relative;top:30px;margin-right: 20px;color:#000;cursor: pointer;"
        >
    </i>
    <el-dialog
      v-model="dialogVisible"
      width="30%"
      v-bind="$attrs"
      @open="onOpen"
      @close="onClose"
      title="密码登录"
    >
      <el-row :gutter="15">
        <el-form
          ref="elForm"
          :model="formData"
          :rules="rules"
          size="medium"
          label-width="150px"
        >
          <el-col :span="24">
            <el-row>
              <el-col :span="22">
                <el-form-item label="手机号" prop="userNickName">
                  <el-input
                    v-model="formData.userNickName"
                    placeholder="请输入手机号"
                    :maxlength="11"
                    show-word-limit
                    clearable
                    prefix-icon="el-icon-phone"
                    :style="{ width: '100%' }"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="22">
                <el-form-item label="密 码" prop="userPasswd">
                  <el-input
                    v-model="formData.userPasswd"
                    placeholder="请输入密码"
                    clearable
                    prefix-icon="el-icon-key"
                    show-password
                    :style="{ width: '100%' }"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-form>
      </el-row>
      <template #footer>
        <div style="padding-right: 50px;">
          <span @click="changeLoginType" style="color: #409eff; cursor: pointer;">
            短信登录
          </span>&nbsp;&nbsp;
          <el-button @click="onClose">取消</el-button>
          <el-button type="primary" @click="userLogin"
            >登&nbsp;&nbsp;&nbsp;&nbsp;录</el-button
          >
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
export default {
  emits: ['changeLoginWayEvent'],
  data () {
    return {
      dialogVisible: false,
      formData: {
        userNickName: '',
        userPasswd: ''
      },
      rules: {
        userNickName: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          },
          {
            pattern: /^1(3|4|5|7|8|9)\d{9}$/,
            message: '手机号格式错误',
            trigger: 'blur'
          }
        ],
        userPasswd: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    changeLoginType () {
      this.$emit('changeLoginWayEvent')
      this.onClose()
    },
    loginCheck () {
      if (this.$store.state.globalObj.nowUserLoginState) {
        this.$router.push('/imgList/barrel').catch(() => {})
        // this.$router.push('/imgTypes').catch(() => {}) // 让vue router帮我们进入目标组件
      } else {
        this.dialogVisible = true
      }
    },
    onOpen () {},
    onClose () {
      this.dialogVisible = false
      this.$refs.elForm.resetFields()
    },
    userLogin () {
      this.$refs.elForm.validate(valid => {
        if (!valid) return
        this.doLogin()
      })
    },
    doLogin () { // 登录
      const api = '/md/front/user/login'
      const params = {
        account: this.formData.userNickName,
        passwd: this.formData.userPasswd
      }
      this.axios.post(api, this.$stringify(params)).then(res => {
        if (res.status === 200) {
          this.$store.commit('setGlobalObjOfNowUserLoginState', true)
          // this.$router.push('/imgTypes').catch(() => {}) // 让vue router帮我们进入目标组件
          // this.$router.push('/imgList/barrel').catch(() => {})
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.bnsize {
  font-size: 20px;
  position: relative;
}

#userLoginPan :deep(.el-input__inner) {
  color: #000;
}

::v-deep .el-dialog__header {
    text-align: center;
}
</style>
